export { default as ExpressCheckout } from './express-checkout.component'
